import PropTypes from 'prop-types'
import React from 'react'
import LogoUpload from '../LogoUpload'
import PurchaseInfo from '../PurchaseInfos'
import UnityDataForm from '../UnityDataForm'

function EventsOthersInfo({ checkIsRed, checkValue }) {
  return (
    <>
      <UnityDataForm title="Informações sobre o Evento" />
      <PurchaseInfo checkIsRed={checkIsRed} checkValue={checkValue} />
      <LogoUpload />
    </>
  )
}

EventsOthersInfo.defaultProps = {
  checkValue: () => {},
  checkIsRed: () => {}
}

EventsOthersInfo.propTypes = {
  checkValue: PropTypes.func,
  checkIsRed: PropTypes.func
}

export default EventsOthersInfo
